import { getIdToken } from '@/lib/auth';

export type HubRole = 'vendor' | 'service_provider';

async function onboardingRolesUrl(): Promise<string | null> {
  const fromEnv = import.meta.env.VITE_ONBOARDING_ROLES_URL;
  if (fromEnv) return fromEnv;
  try {
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    const res = await fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' });
    if (res.ok) {
      const outputs = (await res.json()) as { custom?: { onboardingRolesUrl?: string } };
      return outputs.custom?.onboardingRolesUrl ?? null;
    }
  } catch {
    /* missing outputs */
  }
  return null;
}

/** Assign vendor or service_provider Cognito group after hub onboarding record is created. */
export async function assignHubRole(role: HubRole): Promise<void> {
  const url = await onboardingRolesUrl();
  const token = await getIdToken();
  if (!url || !token) {
    console.warn('[ShopGND] onboarding-roles URL or token missing — skip group assign');
    return;
  }

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ role }),
  });

  if (!res.ok) {
    const payload = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(payload.error ?? `Could not assign ${role} role (${res.status})`);
  }
}
